import { render } from "./ChatContentList.vue?vue&type=template&id=d03c48aa&scoped=true"
import script from "./ChatContentList.vue?vue&type=script&lang=js"
export * from "./ChatContentList.vue?vue&type=script&lang=js"

import "./ChatContentList.vue?vue&type=style&index=0&id=d03c48aa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d03c48aa"]])

export default __exports__